module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7f153e165ee21eaa9b45715d93801a34.png";